import { SimpleAreaChart } from "../Global/SimpleAreaChart"

export const SimpleAreaWidget = (props) => {
    return(
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: props.marginTop, width: '100%', height: props.height}}>
            <SimpleAreaChart data={props.data} domain={props.domain} name={props.name}/>
            <p style={{fontWeight: 'bold', color: '#659767', margin: '5px 0 0 0', fontSize: 'small'}}>{props.label}</p>
        </div>
    )
}